<template>
  <div class="grid-layout" :style="containerStyle">
    <GalleryItem
      v-for="(image, index) in images"
      :key="image.id"
      :image="image"
      :is-loaded="loadedImages[image.id]"
      :container-style="{ aspectRatio: aspectRatioValue }"
      :loading="index < columns * 4 ? 'eager' : 'lazy'"
      :fetch-priority="index < columns * 2 ? 'high' : 'auto'"
      img-mode="bg"
      v-bind="appearance"
      @click="$emit('item-click', $event)"
      @load="$emit('image-load', $event)"
    />
  </div>
</template>

<script>
import GalleryItem from '../GalleryItem.vue'

export default {
  name: 'GridLayout',

  components: { GalleryItem },

  props: {
    images: { type: Array, required: true },
    loadedImages: { type: Object, required: true },
    imageAspectRatios: { type: Object, default: () => ({}) },
    columns: { type: Number, default: 3 },
    maxColumns: { type: Number, default: 3 },
    gap: { type: Number, default: 15 },
    containerWidth: { type: Number, default: 0 },
    aspectRatioValue: { type: String, default: '1 / 1' },
    appearance: { type: Object, default: () => ({}) }
  },

  emits: ['item-click', 'image-load'],

  computed: {
    containerStyle() {
      const maxContainerWidth = this.maxColumns * 400 + (this.maxColumns - 1) * this.gap
      return {
        display: 'grid',
        gridTemplateColumns: `repeat(${this.columns}, minmax(0, 400px))`,
        justifyContent: 'center',
        gap: `${this.gap}px`,
        maxWidth: `${maxContainerWidth}px`,
        margin: '0 auto'
      }
    }
  }
}
</script>
